import ChartMetric from '@/Enums/Chart/Metric.enum';
import { getPublishersGraphData } from '@/helpers/attribution/chartData';
import { downloadCSV } from '@/helpers/downloadCSV';
import { useAppSelector } from '@/store/hooks';
import { selectWebVisitsPublisherNameData } from '@/store/selectors/attribution/webVisits.selectors';
import { useCallback, useMemo } from 'react';
import VerticalChart from '../Charts/VerticalChart';
import GraphCard from './BaseCard/GraphCard';

const label = 'Publisher Name';

const PublisherNameCard = () => {
  const { publisherNameData, publisherNameDataLoading } = useAppSelector(selectWebVisitsPublisherNameData);

  const { chartData, csvData, loading, logos } = useMemo(
    () => getPublishersGraphData(publisherNameData, publisherNameDataLoading),
    [publisherNameData, publisherNameDataLoading],
  );
  const noData = useMemo<boolean>(() => !publisherNameData.length, [publisherNameData.length]);

  const onDownload = useCallback(() => {
    if (!loading) {
      downloadCSV(csvData, label);
    }
  }, [csvData, loading]);

  return (
    <GraphCard label={label} loading={loading} noData={noData} onDownload={onDownload} allowPrint>
      <div className='text-lg w-full flex justify-center'>
        <div className='w-full'>
          <VerticalChart chartData={chartData} logos={logos} legendLabel={ChartMetric.Conversions} paginate />
        </div>
      </div>
    </GraphCard>
  );
};

export default PublisherNameCard;
